module.exports = __webpack_public_path__ + "img/Blocked-middey.0d7de9db.png";